

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class GraphService {
  constructor(private http: HttpClient) {
  }

  getTransactionAmountDay(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/days').pipe(map(data => data));
  }

  getTransactionByDays(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/percent/day').pipe(map(data => data));
  }

  getTransactionByHours(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/percent/hour').pipe(map(data => data));
  }

  getTransactionByService(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/graph/sections').pipe(map(data => data));
  }

  getTransactionAverageAmountTransactionByService(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/graph/sectionavg').pipe(map(data => data));
  }

  getTransactionState(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/state/transaction').pipe(map(data => data));
  }

  getCartsState(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/state/cart').pipe(map(data => data));
  }

  getPosTransaction(): Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/graph/pos/transaction').pipe(map(data => data));
  }

  getAmountCustomer():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/amountcustomer').pipe(map(data => data));
  }

  getDataDepartment():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/').pipe(map(data => data));
  }

  getDataCity():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/amountcity').pipe(map(data => data));
  }

  getDataPOS():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/activitystore').pipe(map(data => data));
  }

  getCartsExpired():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/graph/cart/expire').pipe(map(data => data));
  }

  getDepartment():Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/amount/department').pipe(map(data => data));
  }
}
